(function ($) {
   $(function () {
      const $items = $('.header-open-status .openings-wrapper .opening-item');
      let current = 0;
      let intervalId;

      function showNext() {
         const $currentItem = $items.eq(current);
         $currentItem.removeClass('active fade-in').addClass('fade-out');

         current = (current + 1) % $items.length;
         const $nextItem = $items.eq(current);

         setTimeout(() => {
            $currentItem.removeClass('fade-out');
            $nextItem.addClass('active');
            setTimeout(() => $nextItem.addClass('fade-in'), 10);
         }, 400);
      }

      function startRotation() {
         if (!intervalId) intervalId = setInterval(showNext, 3000);
      }

      function stopRotation() {
         clearInterval(intervalId);
         intervalId = null;
      }

      // Pause when tab is inactive
      document.addEventListener('visibilitychange', function () {
         if (document.hidden) {
            stopRotation();
         } else {
            startRotation();
         }
      });

      // Start initially
      startRotation();
   });
})(jQuery);
